<template>
  <section>
    <b-row v-if="loading">
      <b-col
        sm="12"
        class="text-center"
      >
        <b-skeleton
          class="d-inline-block"
          animation="wave"
          width="40%"
          height="200px"
        />
      </b-col>
    </b-row>
    <b-container
      v-else
      class="container-small"
    >
      <b-card>
        <b-form-group
          class="mb-2"
          :label="$tk('ClientPortal.Sidebar.Create.ChooseAnExistingAdGroup')"
          label-for="input-choose-existing"
        >
          <multiselect
            :options="campaigns"
            :preserve-search="true"
            :close-on-select="true"
            group-values="adGroups"
            group-label="name"
            :group-select="false"
            track-by="name"
            label="name"
            :show-labels="false"
            @select="(selectedOption, id) => chooseAdGroup(selectedOption)"
          >
            <template slot="placeholder">
              <span class="multiselect__placeholder mb-0">{{ $tk('ClientPortal.Sidebar.Create.SelectAdGroup') }}</span>
            </template>
            <!-- Oops! No elements found. Consider changing the search query. -->
            <span slot="noResult"> {{ $tk('ClientPortal.Sidebar.NoElementsFound') }}.</span>
            <template
              slot="option"
              slot-scope="props"
            >
              <div class="option__desc">
                <span
                  v-if="props.option.$groupLabel"
                  class="option__title option__title--disabled"
                >
                  {{ props.option.$groupLabel }}
                </span>
                <span
                  v-else
                  class="option__title m-1"
                >
                  {{ props.option.name }}
                </span>
              </div>
            </template>
            <template slot="caret" slot-scope="{ toggle }">
              <div @mousedown.prevent.stop="toggle()" class="multiselect__select">
                <GjIcon
                  class="icon-wrapper"
                  name="ArrowDown_fill"
                  size="21"
                />
              </div>
            </template>
          </multiselect>
        </b-form-group>
        <text-divider :text="$tk('ClientPortal.Sidebar.Create.Or')" />
        <div class="text-center mt-2">
          <div class="container-small mx-auto">
            <b-button
              variant="outline-primary"
              size="sm"
              :to="'/' + this.$route.params.accountId + '/adgroup/create'"
            >
              <GjIcon
                name="Plus"
                class="mr-50"
              />
              {{ $tk('ClientPortal.Sidebar.Create.CreateANewAdGroup') }}
            </b-button>
          </div>
        </div>
      </b-card>
    </b-container>
  </section>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import Multiselect from 'vue-multiselect'
import CampaignsAdGroups from '@/api/client/campaignsAdgroups.service'
import notification from '@/mixins/toastification'
import TextDivider from '@/components/TextDivider.vue'

export default {
  components: {
    GjIcon,
    Multiselect,
    TextDivider,
  },
  mixins: [notification],
  data() {
    return {
      loading: false,
      campaigns: [],
      campaign: null,
      adGroups: [],
    }
  },
  watch: {
    '$route.params.accountId': 'fetchData',
  },
  async mounted() {
    await this.fetchData()
  },
  methods: {
    chooseAdGroup(selectedOption) {
      this.$router.push(`/${this.$route.params.accountId}/ad/create?adGroupId=${selectedOption.id}`)
    },
    async fetchData() {
      this.loading = true
      try {
        const response = await CampaignsAdGroups.getCampaignsAdGroups(this.$route.params.accountId)
        this.campaigns = response
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<!-- Create new scss file if you add more than two classes inside component -->
<style lang="scss" >
@import '@/assets/scss/libs/_vue-multiselect.scss';
</style>
